// services/annonceService.ts

import { Annonce } from "../types/features/Annonce";
import { PaginatedResponse } from "../types/core/PaginatedResponse";
import { apiClient } from "../utils/apiClient";

export interface Recipient {
    id: string;
    name: string;
    email: string;
    type: "entreprise" | "agent" | "admin";
}

export const annonceService = {
    // Récupérer les annonces
    async getAnnonces(page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Annonce>> {
        const response = await apiClient.get<PaginatedResponse<Annonce>>('/annonces', {
            params: { page, per_page: perPage },
        });
        return response.data;
    },

    // Récupérer une annonce
    async getAnnonceById(id: string): Promise<Annonce> {
        const response = await apiClient.get<{ statusCode: number; data: Annonce }>(`/annonces/${id}`);
        return response.data.data;
    },

    // Récupérer la liste des destinataires
    async getRecipients(): Promise<Recipient[]> {
        const response = await apiClient.get<{ statusCode: number; data: Recipient[] }>('/annonces/recipients');
        return response.data.data;
    },

    // Créer une annonce
    async createAnnonce(data: any): Promise<Annonce> {
        const response = await apiClient.post<{ statusCode: number; message: string; data: Annonce }>('/annonces', data);
        return response.data.data;
    },

    // Mettre à jour une annonce
    async updateAnnonce(id: string, data: any): Promise<Annonce> {
        const response = await apiClient.put<{ statusCode: number; message: string; data: Annonce }>(`/annonces/${id}`, data);
        return response.data.data;
    },

    // Supprimer une annonce
    async deleteAnnonce(id: string): Promise<void> {
        await apiClient.delete(`/annonces/${id}`);
    },

    // Publier une annonce
    async publishAnnonce(id: string): Promise<Annonce> {
        const response = await apiClient.post<{ statusCode: number; message: string; data: Annonce }>(`/annonces/${id}/publish`);
        return response.data.data;
    },
};